import { on, select } from 'helpers/dom'
import './notice-main.css'

const selectors = {
  CLOSE_NOTICE_SELECTOR: '.js-close-notice',
  AUTO_CLOSE_NOTICE_SELECTOR: '.js-auto-close-notice',
  NOTICE_HIDE_CLASS: 'notice-hidden'
}

class NoticeMain extends HTMLElement {
  constructor() {
    super()

    this.closeBtn = select(selectors.CLOSE_NOTICE_SELECTOR, this)
    this.timeDelay = this.getAttribute('data-time-delay')

    this.addEvents()
  }

  addEvents() {
    if (this.closeBtn) {
      on('click', this.hide.bind(this), this.closeBtn)
    }

    if (this.timeDelay) {
      setTimeout(this.hide.bind(this), this.timeDelay)
    }
  }

  hide() {
    this.classList.add(selectors.NOTICE_HIDE_CLASS)
  }
}

customElements.define('notice-main', NoticeMain)
